namespace $.$$ {
	export class $shm_hitalama_text_embed_image extends $.$shm_hitalama_text_embed_image {
		@ $mol_action
		open( event?: Event ) {
			event?.preventDefault()
			event?.stopPropagation()
			return super.open( event )
		}
	}
}
